import React, { useCallback } from "react";
import { ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { useSnapshot } from "valtio";
import {
    setIsModalApkOpened,
    setIsModalOpened,
    setIuudApk,
    store,
} from "./store";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { useSelector } from "react-redux";
import { t } from "i18next";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { StyledModal } from "@aureskonnect/react-ui";
import { AvForm, AvRadioGroup, AvRadio } from "availity-reactstrap-validation";
import { store as useStore } from "@components/VerticalLayout/store";
import { getDataShop } from "./ModalWrapper/hooks";
import { useFetchGlobal } from "../../../../api/hooks";

function ApkModal({
    selectedRow,
    setMergedData,
    setIsFetchingData,
}: {
    selectedRow: any;
    setMergedData: Function;
    setIsFetchingData: Function;
}) {
    const { fetchGlobal } = useFetchGlobal();

    const { isModalApkOpened } = useSnapshot(store);
    const { franchiseID, userID } = useSnapshot(useStore);
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [selectedApk, setSelectedApk] = React.useState("");
    const apks = [...selectedRow.iuudApk].sort((a, b) =>
        a.nom.localeCompare(b.nom, "fr", { sensitivity: "base" })
    );
    const toggleModal = useCallback(() => {
        setIsModalApkOpened(!isModalApkOpened);
    }, [isModalApkOpened]);
    const handleSave = useCallback(async () => {
        setIsModalApkOpened(false);
        setIuudApk(selectedApk);
        await getDataShop(
            selectedApk,
            selectedRow,
            franchiseID,
            userID,
            setMergedData,
            setIsFetchingData,
            fetchGlobal
        );
        setIsModalOpened(true);
    }, [
        selectedApk,
        selectedRow,
        franchiseID,
        userID,
        setMergedData,
        setIsFetchingData,
        fetchGlobal,
    ]);

    return (
        <StyledModal
            centered
            backdrop="static"
            fade={false}
            scrollable
            toggle={toggleModal}
            isOpen={isModalApkOpened}
            style={{ maxWidth: "650px" }}
        >
            <ModalHeader
                toggle={toggleModal}
                className="text-uppercase modal-wrapper-title__clz"
            >
                {t("Select APK")}
                {selectedRow.Boutique !== "" &&
                selectedRow.Boutique !== null &&
                selectedRow.Boutique !== undefined
                    ? ` - ${selectedRow.Boutique}`
                    : ""}
            </ModalHeader>

            <ModalBody className="p-3">
                <AvForm>
                    <h6 className="pt-3 pb-1 ml-3">
                        {t(
                            "Veuillez sélectionner l'APK que vous souhaitez modifier :"
                        )}
                    </h6>
                    <AvRadioGroup
                        name="form"
                        required
                        inline
                        style={{
                            maxHeight: "35vh",
                            overflowY: "auto",
                            scrollbarWidth: "none",
                        }}
                    >
                        {apks?.map((apk: any) => (
                            <div key={apk.iuud} className="p-2 px-4 ml-5">
                                <AvRadio
                                    className="cac_chk_nextInTheList"
                                    id={apk.iuud}
                                    label={
                                        <span className="font-bold">
                                            {apk.nom}
                                        </span>
                                    }
                                    value={apk.iuud}
                                    disabled={false}
                                    onChange={(e: any) => {
                                        setSelectedApk(e.target.value);
                                    }}
                                />
                            </div>
                        ))}
                    </AvRadioGroup>
                </AvForm>
            </ModalBody>

            <ModalFooter>
                <CustomSecondaryColorButton
                    className="w-20"
                    rounded
                    onClick={toggleModal}
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>

                <CustomMainColorButton
                    className="w-20"
                    rounded
                    disabled={!selectedApk}
                    color={mainColor}
                    onClick={handleSave}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}

export default ApkModal;
